<template>
  <div>
    <loading :active.sync="isLoading" :enforce-focus="false"></loading>
    <!-- 複数選択 モーダル -->
    <b-modal ref="select-mitumori" id="select-mitumori" title="見積選択" size="xl" :header-bg-variant="'dark'"
      :header-text-variant="'light'" :body-bg-variant="'light'" @hide="onModalHide" hide-footer centered>
      <div class="main_modal_div">
        <div style="margin-bottom: 5px;" class="form-inline">
          <b-form-select v-model="on_type2" style="width: 100px" @change="onDateChange">
            <option v-for="option in sel_on_type" v-bind:value="option.value" :key="option.id">
              {{ option.text }}
            </option>
          </b-form-select>
          <v-date-picker v-model="sel_date1" @input="onDateChange" class="date_picker" is-required>
            <template v-slot="{ inputValue, inputEvents }">
              <b-input :value="inputValue" v-on="inputEvents" readonly />
            </template>
          </v-date-picker>
          &nbsp;-&nbsp;
          <v-date-picker v-model="sel_date2" @input="onDateChange" class="date_picker" is-required>
            <template v-slot="{ inputValue, inputEvents }">
              <b-input :value="inputValue" v-on="inputEvents" readonly />
            </template>
          </v-date-picker>
        </div>
        <div style="width: 1200px; ">
          <b-table-filter-pager :busy="mitumori_sel_load" :maxHeight="maxHeight2" :filter_list="sel_filter_list"
            :filter_val="sel_filter_val" :filter_val_ex="sel_filter_val_ex" :data_count="sel_data_count"
            :data_list_field="sel_data_list_field" :data_list="sel_data_list" 
            :currentPage="current_page" @on_sort="onSort" @jyutyu_show="jyutyuShow" @nouhin_show="nouhinShow"
            @seikyu_show="seikyuShow" @nyukin_show="nyukinShow" 
            @on_page_change='onSelPageChange' @on_filter_ex='onSelFilterEx' @on_mitumori_sel="onSelect" :nav_flg="true"
            :filter_enable="true" :add_btn="false" />
        </div>
      </div>
    </b-modal>
    <!-- 受注 詳細 -->
    <JyutyuDetail ref="child_jyutyu_detail3" :modal_id="'main-jyutyu_detail3'" @close_modal='closeModal2' />
    <!-- 納品 詳細 -->
    <NouhinDetail ref="child_nouhin_detail3" :modal_id="'main-nouhin_detail3'" @close_modal='closeModal2' />
    <!-- 請求 詳細 -->
    <SeikyuDetail ref="child_seikyu_detail3" :modal_id="'main-seikyu_detail3'" @close_modal='closeModal2' />
    <!-- 入金 -->
    <NyukinDetail ref="child_nyukin_detail3" :modal_id="'main-nyukin_detail3'" @close_modal='closeModal2' />

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';

import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

const jsonpAdapter = require('axios-jsonp');
export default {
  props: ['modal_id'],
  data: function () {
    return {
      isLoading: false,
      mitumori_sel_load: false,
      sel_on_type: [{ value: 0, text: "見積日" }, { value: 1, text: "受注日" },
      { value: 2, text: "納品日" }, { value: 3, text: "請求日" }],
      filter_val_ex: new Array(15),
      // datepickerでdefaultが空の場合、時刻がおかしくなる(Timezone)ので日付けのみに変換
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
      // 複数選択
      current_page: 1,
      busy: false,
      sort_by: '',
      sort_desc: true,
      print_loading: false,
      nouhin_on_print_flg: true,
      seikyu_on_print_flg: true,
      on_type2: 0,
      sel_date1: '',
      sel_date2: '',
      sel_id: [],
      submit_sel_id: [],
      sel_filter_list: new Array(15),
      sel_filter_val: new Array(15),
      sel_filter_val_ex: new Array(15),
      sel_data_count: 0,
      sel_data_list: [],
      sel_data_list_field: [
        { key: "mitumori_sel", label: "選択", thStyle: { width: "60px", textAlign: "center" }, tdClass: 'text-center', sortable: false,  },
        { key: "jyutyu_status", label: "受注", thStyle: { width: "70px", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: 'select_sts_ex' },
        { key: "nouhin_status", label: "納品", thStyle: { width: "70px", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: 'select_sts_ex' },
        { key: "seikyu_status", label: "請求", thStyle: { width: "70px", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: 'select_sts_ex' },
        { key: "nyukin_status", label: "入金", thStyle: { width: "70px", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: 'select_sts_ex' },
        { key: "m_code", label: "伝票番号", thStyle: { width: "100px" }, sortable: true, filter: 'input_ex' },
        { key: "title", label: "品題", thStyle: { width: "180px" }, sortable: true, filter: 'input_ex' },
        { key: "teiki_type1", label: "品類", thStyle: { width: "120px" }, sortable: true, filter: 'input_ex' },
        { key: "teiki_type2", label: "品目", thStyle: { width: "120px" }, sortable: true, filter: 'input_ex' },
        { key: "mitumori_on", label: "見積日", thStyle: { width: "140px" }, sortable: true, filter: 'input_ex' },
        { key: "client_company_name", label: "顧客", thStyle: {}, sortable: true, filter: 'input_ex' },
      ],
      // 処理
      on_submit: -1,
      sel_on_submit: [{ value: 0, text: "複製" }, { value: 1, text: "置換" },
      { value: 2, text: "受注確定" }, { value: 3, text: "納品済み" },
      { value: 4, text: "請求済み" }, { value: 5, text: "納品・請求済み" }],
      // 置換
      tikan_title: '複製',
      tikan_type: 0,
      tikan_name_list: ["品題", "品類", "品目", "顧客", "見積日", "納品日", "請求日"],
      tikan_chk: [false, false, false, false, false, false, false],
      tikan: ["", "", "", 0, "", "", ""],
      tikan_client_company_name: "",
      //
      msg: 'msg',
      showModal: false,
      deleteTarget: -1,
      errors: [],
      maxHeight2: document.documentElement.scrollHeight - 360 + "px"
    }
  },
  mounted() {
    this.checkLogin();
    this.getSelectList();
  },
  methods: {
    onModalHide: function () {

    },
    // =======================================================
    onSelPageChange: function (current_page) {
      this.current_page = current_page;
      this.getSelectList();
    },
    //
    onDateChange: function () {
      this.sel_id = []
      this.current_page = 1;
      this.getSelectList();
    },
    //
    onSelFilterEx: function () {
      this.sel_id = []
      this.current_page = 1;
      this.getSelectList();
    },
    // 複数選択 一覧取得
    getSelectList: function () {
      this.isLoading = true;
      this.sel_id = []
      axios
        .get('/mitumori/get_mitumori_list', {
          params: {
            on_type: this.on_type2, date1: this.sel_date1, date2: this.sel_date2,
            jyutyu_sts_ex: this.sel_filter_val_ex[1], nouhin_sts_ex: this.sel_filter_val_ex[2],
            seikyu_sts_ex: this.sel_filter_val_ex[3], nyukin_sts_ex: this.sel_filter_val_ex[4],
            m_code_ex: this.sel_filter_val_ex[5], title_ex: this.sel_filter_val_ex[6],
            teiki_type1_ex: this.sel_filter_val_ex[7], teiki_type2_ex: this.sel_filter_val_ex[8],
            mitumori_on_ex: this.sel_filter_val_ex[9], client_company_name_ex: this.sel_filter_val_ex[10],
            address_ex: this.sel_filter_val_ex[11],
            mitumori_sel_id: this.sel_id,
            sort_by: this.sort_by, sort_desc: this.sort_desc,
            current_page: this.current_page
          }
        })
        .then(response => {
          this.sel_data_list_field[9]["label"] = this.sel_on_type[this.on_type2]["text"]
          this.sel_data_list = response.data.mitumori_list;
          this.sel_data_count = response.data.mitumori_cnt;
          this.sel_date1 = response.data.date1;
          this.sel_date2 = response.data.date2;
          this.sel_filter_list[1] = response.data.jyutyu_status_filter_list;
          this.sel_filter_list[2] = response.data.nouhin_status_filter_list;
          this.sel_filter_list[3] = response.data.seikyu_status_filter_list;
          this.sel_filter_list[4] = response.data.nyukin_status_filter_list;
          this.on_submit = -1;
          this.mitumori_sel_load = false;
          this.isLoading = false;

        })
    },
    // 選択
    onSelect: function (index, id, m_code_ex, event) {
      this.$emit('on_select', id);
    },  
 
    // =======================================================
    //
    closeModal: function (id) {
      this.$emit('close_modal', id);
    },
    closeModal2: function () {
    },

    // =======================================================
    // 受注表示
    jyutyuShow: function (mitumori_id) {
      this.$refs.child_jyutyu_detail3.getMitumori2Jyutyu(mitumori_id);
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'main-jyutyu_detail3');
      }, 100);
    },
    // 納品詳細
    nouhinShow: function (mitumori_id) {
      this.$refs.child_nouhin_detail3.getMitumori2Nouhin(mitumori_id);
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'main-nouhin_detail3');
      }, 100);
    },
    // 請求詳細
    seikyuShow: function (mitumori_id) {
      this.$refs.child_seikyu_detail3.getMitumori2Nouhin(mitumori_id);
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'main-seikyu_detail3');
      }, 100);
    },
    // 入金
    nyukinShow: function (mitumori_id) {
      this.$refs.child_nyukin_detail3.getMitumori2Nyukin(mitumori_id);
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'main-nyukin_detail3');
      }, 100);
    },
    // 複製・置換モーダルClose
    closeTikanModal: function () {
      this.on_submit = -1;
    },
    // ソート
    onSort: function (ctx) {
      this.sort_by = ctx.sortBy;
      this.sort_desc = ctx.sortDesc;
      this.getSelectList();
    }
  }

}
</script>

<style scoped></style>